'use client';

import { LandingPage } from '@sapientpro/sapientpro-data-models';
import styles from './POSTerminal.module.scss';

const LandingHeroVideo = ({ backgroundVideo }: { backgroundVideo: LandingPage['backgroundVideo'] }) => {
  const videoTypeSuffix = backgroundVideo ? backgroundVideo?.ext?.slice(1) : '';

  return (
    <div className={styles.headerSection__videoWrapper}>
      <video
        autoPlay
        loop
        muted
        playsInline
        className={styles.headerSection__video}
        onClick={(e) => e.preventDefault()}
      >
        <source
          src={backgroundVideo?.url}
          type={`video/${videoTypeSuffix}`}
        />
      </video>
      <div className={styles.headerSection__videoWrapperOverlay} />
    </div>
  );
};

export default LandingHeroVideo;
